import React, { memo } from "react";
import { PerformerParkingWrapper } from "./style";

const KTPerformerParking = memo(() => {
  return <PerformerParkingWrapper>KTArtistParking</PerformerParkingWrapper>;
});

export default KTPerformerParking;
